/**
 * The default width of lines drawn on line plots in pixels of the target html5 canvas.
 */
export const DEFAULT_LINE_WIDTH = 1;

/**
 * The default radius of points drawn on line plots in pixels of the target html5 canvas.
 */
export const DEFAULT_POINT_RADIUS = 1.5;
